'use client'; // Add this at the very top of the file

import { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import './App.css';
const FORMSPARK_FORM_ID = '79WNeHAAb'; // Replace with your actual Formspark Form ID

const App = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [email, setEmail] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState<'success' | 'error' | null>(null); // 'success', 'error', null
  const successControls = useAnimation();
  const errorControls = useAnimation();

  useEffect(() => {
    if (submissionStatus === 'success') {
      successControls.start({ opacity: 1, y: 0, transition: { duration: 0.5 } });
    } else {
      successControls.start({ opacity: 0, y: 10, transition: { duration: 0.5 } });
    }
  }, [submissionStatus, successControls]);

  useEffect(() => {
    if (submissionStatus === 'error') {
      errorControls.start({ opacity: 1, y: 0, transition: { duration: 0.5 } });
    } else {
      errorControls.start({ opacity: 0, y: 10, transition: { duration: 0.5 } });
    }
  }, [submissionStatus, errorControls]);

  const handleSubmit = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    setSubmissionStatus(null); // Reset status

    try {
      const response = await fetch(`https://submit-form.com/${FORMSPARK_FORM_ID}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        console.log('Newsletter signup:', email);
        setEmail('');
        setSubmissionStatus('success');
      } else {
        console.error('Form submission error:', response.status, response.statusText);
        setSubmissionStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmissionStatus('error');
    }
  };

  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="app">
      <nav className="top-nav">
        <div className="top-nav-meta">
          <p className="nav-label">Recents/Trending:</p>
          <p className="nav-text">{isMobile ? 'HappyHour.Studio' : 'HappyHour.Studio - Building cool sh*t'}</p>
        </div>
        <div className="nav-section">
          <div className="nav-buttons">
            <motion.button
              id="stupidButton"
              whileHover={{ scale: 1.1, rotate: [0, -10, 10, -10, 0] }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 300 }}
              style={{ originX: 0.5, originY: 0.5 }}
            >
              <a
                href="https://dumbbutton.press"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                DUMB BUTTON
              </a>
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.1, rotate: [0, 10, -10, 10, 0] }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 300 }}
              style={{
                originX: 0.5,
                originY: 0.5,
                background: 'linear-gradient(90deg, #3b82f6 0%, #3b82f6 100%)',
                color: 'white',
              }}
            >
              <a
                href="https://trythis-e1655.web.app"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                Rental Woes
              </a>
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.1, rotate: [0, -5, 5, -5, 0] }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 300 }}
              style={{ originX: 0.5, originY: 0.5 }}
            >
              <a>
                Coming Soon...
              </a>
            </motion.button>
          </div>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="title-container">
              <h1>
                <img src="/logo.png" alt="HappyHour Studio" className="hero-logo" />
              </h1>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="hero-description-container">
        <div className="container">
          <motion.p
            className="hero-description"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }} // Increased delay
          >
            Building like sugar-crazed toddlers with unlimited budgets
          </motion.p>
          <motion.p
            className="subtitle"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }} // Increased delay
          >
            Dedicated to building cool sh*t
          </motion.p>
          <motion.p
            className="signup-text"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
          </motion.p>
          <motion.form
            className="signup-form"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            onSubmit={handleSubmit}
          >
            <input
              type="email"
              className="signup-input"
              placeholder="Stay in the loop..."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              className="signup-button"
              disabled={submissionStatus === 'success'}
              onClick={() => {
                if (submissionStatus === 'success') {
                  window.location.href = 'https://trythis-e1655.web.app';
                }
              }}
            >
              {submissionStatus === 'success' ? '✓' : '→'}
            </button>
          </motion.form>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={successControls}
            className="success-message"
          >
            You're in!
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={errorControls}
            className="error-message"
          >
            Oops! Something went wrong.
          </motion.p>
        </div>
      </section>

      <footer className="info-footer">
        <div className="footer-left">
          <div className="logo">
            <div className="cartoon-eyes-small">
              <div className="eye"></div>
              <div className="cloud"></div>
            </div>
          </div>
          <div className="footer-section">
            <h3>For-Profit</h3>
            <ul>
              {[
                'Dumb Button',
                'Coming Soon...',
                'Coming Soon...',
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item === 'Dumb Button' ? 'https://dumbbutton.press' : `#${item.replace(/\s+/g, '-').toLowerCase()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-profit"
                  >
                    {item} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Not For-Profit</h3>
            <ul>
              {[
                'Rental Woes',
                'Coming Soon...',
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item === 'Rental Woes' ? 'https://trythis-e1655.web.app' : `#${item.replace(/\s+/g, '-').toLowerCase()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-nonprofit"
                  >
                    {item} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>We're Being Sued</h3>
            <ul>
              {['Coming Soon...'].map((item, index) => (
                <li key={index}>
                  <a
                    href={`#${item.replace(/\s+/g, '-').toLowerCase()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-sued"
                  >
                    {item} ↗
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="footer-center">
          <h3>Get in Touch</h3>
          <p>Got an idea? Want it built? Fund a project?</p>
          <a href="mailto:happyhcontact@gmail.com" className="email-link">happyhcontact@gmail.com</a>
        </div>
        <div className="footer-right">
          <h3>HappyHour</h3>
          <p>
            Remember when the internet felt like a playground instead of a productivity prison? We're bringing back that magic - one ridiculous creation at a time. Consider this your hall pass from adulting.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default App;